export enum PonticDesignEnum {
	RidgeLapPontic = 1,
	ModifiedRidgeLapPontic = 2,
	SteinPontic = 3,
	SanitaryPontic = 4,
	OvalePontic = 5
}
